import useBeautyFilterTitle from 'hooks/beautyFilter/useBeautyFilterTitle';
const BeautyFilterTitle: React.FC = () => {
  const { title, isBackButtonVisible, handleBackButtonClick } = useBeautyFilterTitle();

  return (
    <div className="typography-headline-lg flex h-16 items-center gap-2 p-4">
      <div onClick={handleBackButtonClick} style={{ display: isBackButtonVisible ? 'flex' : 'none' }} className="items-center justify-center">
        <img className="h-6 w-6 rotate-180 rtl:rotate-0" src="/imgweb/etc/arrow_right_white.svg" alt="back" />
      </div>
      {title}
    </div>
  );
};

export default BeautyFilterTitle;
